import { render, staticRenderFns } from "./UserDiscount.vue?vue&type=template&id=3c17fd8b&scoped=true&"
import script from "./UserDiscount.vue?vue&type=script&lang=js&"
export * from "./UserDiscount.vue?vue&type=script&lang=js&"
import style0 from "./UserDiscount.vue?vue&type=style&index=0&id=3c17fd8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17fd8b",
  null
  
)

export default component.exports